import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import './App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleRight, faCircleCheck, faSun, faCircle, faLocationDot, faClock, faArrowRightLong, faStar, faBars, faCaretUp, faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { useEffect, useState } from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import PageLoader from "./components/PageLoader";

function App() {
  const [loading, setLoading] = useState(true);
  const [coins, setCoins] = useState([]);
  const [news, setNews] = useState([]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    fetch(`apixxxall_coin.txt`)
    .then((res) => res.json())
    .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          percentage: Number(coin.quote.USD.percent_change_24h.toFixed(2))
      }));
      setCoins(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`apixxx_market.txt`)
    .then((res) => res.json())
    .then((data) => {
      console.log(data.results);
      var newsList = data.results;
      const updatedData = newsList.map((newss, index) => ({
        id: index + 1,
        image: newss.image_url ? newss.image_url : 'https://res.cloudinary.com/coinpaper/image/upload/v1680001325/arb_fba92b25bc.png',
        title: newss.title,
        date: newss.pubDate,
        country: newss.country?.[0] || "unknown",
      }));
      setNews(updatedData);
    })
    .catch((err) => console.error("Error loading news list:", err));
  }, []);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className='overflow-hidden'>
      <div className="homebgd" style={{backgroundImage: "url('/img/home-hero@1x.webp')",position:'relative'}}>
        <div className='preview-block__bg'></div>
        <div className="rounded-5 p-4 sidenav">
          <nav className='flex-column d-flex justify-content-center h-100'>
            <a href='/' className='active'>Cryptocurrencies</a>
            <a href='/'>Exchanges</a>
            <a href='/'>Wallets</a>
            <a href='/'>News</a>
            <a href='/'>Data</a>
            <a href='/'>Newsletter</a>
          </nav>
        </div>
        <header className="header" style={{position:'relative', zIndex: 3}}>
          <div className='d-flex align-items-center'>
            <img src="./img/logo.png" alt="Company Logo" style={{height: '30px'}} />
            <nav className='ms-4'>
              <a href='/' className='active hasdrop'>Cryptocurrencies
                <div className='customdropdown'>
                  <a href='/' className='hassubdrop'>
                    <div className='d-flex align-items-center justify-content-between'>
                      <span>Rankings</span>
                      <div className='d-flex align-items-center'>
                        <span className='px-1 rounded-1 bg-info fw-semibold text-white' style={{fontSize: '10px'}}>Top</span>
                        <FontAwesomeIcon icon={faAngleRight} className='ms-1 fs-7' />
                      </div>
                    </div>
                    <div className='subcustomdropdown'>
                      {coins.slice(0, 7).map((coin) => (
                        <div key={coin.id} className='rounded-4 border d-flex align-items-end justify-content-between p-2 mb-1'>
                          <div className='d-flex align-items-center'>
                            <img src={coin.logo} alt={coin.name} style={{width: '25px'}} />
                            <div className='ms-2'>
                              <h6 className='mb-0 fw-bold'>{coin.name}</h6>
                              <p className='fw-semibold mb-0'>${coin.price}</p>
                            </div>
                          </div>
                          <p className={`mb-0 ${coin.percentage > 0 ? 'text-success' : 'text-danger'} fw-bold`} style={{fontSize: '14px'}}><FontAwesomeIcon icon={coin.percentage > 0 ? faCaretUp : faCaretDown} className='me-1' /> {coin.percentage}%</p>
                        </div>
                      ))}
                    </div>
                  </a>
                  <a href='/' className='hassubdrop'>
                    <div className='d-flex align-items-center justify-content-between'>
                      <span>Crypto Prices</span>
                      <FontAwesomeIcon icon={faAngleRight} className='ms-1 fs-7' />
                    </div>
                    <div className='subcustomdropdown'>
                      {coins.slice(0, 50).map((coin) => (
                        <div key={coin.id} className='rounded-4 border d-flex align-items-end justify-content-between p-2 mb-1'>
                          <div className='d-flex align-items-center'>
                            <img src={coin.logo} alt={coin.name} style={{width: '25px'}} />
                            <div className='ms-2'>
                              <h6 className='mb-0 fw-bold'>{coin.name}</h6>
                              <p className='fw-semibold mb-0'>${coin.price}</p>
                            </div>
                          </div>
                          <p className={`mb-0 ${coin.percentage > 0 ? 'text-success' : 'text-danger'} fw-bold`} style={{fontSize: '14px'}}><FontAwesomeIcon icon={coin.percentage > 0 ? faCaretUp : faCaretDown} className='me-1' /> {coin.percentage}%</p>
                        </div>
                      ))}
                    </div>
                  </a>
                  <a href='/'>Top Gainers & Losers</a>
                  <a href='/'>Crypto Market Overview</a>
                  <a href='/'>
                    <div className='d-flex align-items-center justify-content-between'>
                      <span>Fear And Greed Index </span>
                      <span className='px-1 rounded-1 bg-danger fw-semibold text-white' style={{fontSize: '10px'}}>Trending</span>
                    </div>
                  </a>
                  <a href='/' className='hassubdrop'>
                    <div className='d-flex align-items-center justify-content-between'>
                      <span>Buy Cryptocurrency</span>
                      <FontAwesomeIcon icon={faAngleRight} className='ms-1 fs-7' />
                    </div>
                    <div className='subcustomdropdown' style={{minWidth: '500px'}}>
                      <div className='row'>
                        {coins.slice(0, 6).map((coin) => (
                        <div className='col-6'>
                          <div className='rounded-4 border d-flex align-items-end justify-content-between py-2 mb-2'>
                            <div className='d-flex align-items-center flex-column w-100'>
                              <img src={coin.logo} alt={coin.name} style={{width: '30px'}} />
                              <h6 className='mb-0 fw-bold mt-0' style={{fontSize: '14px'}}>{coin.name} ({coin.symbol})</h6>
                              <div className='d-flex align-items-center mb-0'>
                                <p className='fw-semibold mb-0' style={{fontSize: '18px'}}>${coin.price}</p>
                                <p className={`mb-0 ${coin.percentage > 0 ? 'text-success' : 'text-danger'} fw-bold`} style={{fontSize: '14px'}}><FontAwesomeIcon icon={coin.percentage > 0 ? faCaretUp : faCaretDown} className='ms-3' /> {coin.percentage}%</p>
                              </div>
                              <a href='/' className='px-2 py-1 rounded-3 bg-success text-white fw-semibold'>Buy {coin.symbol}</a>
                            </div>
                          </div>
                        </div>
                        ))}
                      </div>
                    </div>
                  </a>
                  <a href='/' className='hassubdrop'>
                    <div className='d-flex align-items-center justify-content-between'>
                      <span>News</span>
                      <FontAwesomeIcon icon={faAngleRight} className='ms-1 fs-7' />
                    </div>
                    <div className='subcustomdropdown' style={{minWidth: '330px'}}>
                      {news.slice(0, 5).reverse().map((newItem) => (
                      <div key={newItem.id} className='rounded-4 border d-flex p-2 mb-2'>
                        <div className='rounded-3 d-flex align-items-center justify-content-center overflow-hidden' style={{width: '110px', height: '70px', minWidth: '110px', minHeight: '70px'}}>
                          <img src={newItem.image || 'https://res.cloudinary.com/coinpaper/image/upload/v1680001325/arb_fba92b25bc.png'}alt={newItem.title}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = 'https://res.cloudinary.com/coinpaper/image/upload/v1680001325/arb_fba92b25bc.png'; // Fallback image
                          }} style={{width: '100%', height: '100%',objectFit: 'cover'}} />
                        </div>
                        <div className='flex-1 ms-2'>
                          <h6 className="mb-0 fw-semibold" style={{ fontSize: '14px' }}>
                            {newItem.title.split(' ').length <= 10
                              ? newItem.title
                              : `${newItem.title.split(' ').slice(0, 10).join(' ')}...`}
                          </h6>
                          <span className='mb-0' style={{fontSize: '10px', color: 'gray'}}>{newItem.date}</span>
                        </div>
                      </div>
                      ))}
                    </div>
                  </a>
                </div>
              </a>
              <a href='/' className='hasdrop'>Exchanges
                <div className='customdropdown'>
                  <a href='/'>
                    <div className='d-flex align-items-center justify-content-between'>
                      <span>Spot</span>
                    </div>
                  </a>
                  <a href='/'>
                    <div className='d-flex align-items-center justify-content-between'>
                      <span>DEX</span>
                    </div>
                  </a>
                  <a href='/'>
                    <div className='d-flex align-items-center justify-content-between'>
                      <span>Top Exchanges</span>
                      <span className='px-1 rounded-1 bg-danger fw-semibold text-white' style={{fontSize: '10px'}}>Hot</span>
                    </div>
                  </a>
                  <a href='/' className='hassubdrop'>
                    <div className='d-flex align-items-center justify-content-between'>
                      <span>News</span>
                      <FontAwesomeIcon icon={faAngleRight} className='ms-1 fs-7'/>
                    </div>
                    <div className='subcustomdropdown' style={{minWidth: '330px'}}>
                      {news.slice(0, 5).reverse().map((newItem) => (
                      <div key={newItem.id} className='rounded-4 border d-flex p-2 mb-2'>
                        <div className='rounded-3 d-flex align-items-center justify-content-center overflow-hidden' style={{width: '110px', height: '70px', minWidth: '110px', minHeight: '70px'}}>
                          <img src={newItem.image || 'https://res.cloudinary.com/coinpaper/image/upload/v1680001325/arb_fba92b25bc.png'}alt={newItem.title}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = 'https://res.cloudinary.com/coinpaper/image/upload/v1680001325/arb_fba92b25bc.png'; // Fallback image
                          }} style={{width: '100%', height: '100%',objectFit: 'cover'}} />
                        </div>
                        <div className='flex-1 ms-2'>
                          <h6 className="mb-0 fw-semibold" style={{ fontSize: '14px' }}>
                            {newItem.title.split(' ').length <= 10
                              ? newItem.title
                              : `${newItem.title.split(' ').slice(0, 10).join(' ')}...`}
                          </h6>
                          <span className='mb-0' style={{fontSize: '10px', color: 'gray'}}>{newItem.date}</span>
                        </div>
                      </div>
                      ))}
                    </div>
                  </a>
                </div>
              </a>
              <a href='/'>Wallets</a>
              <a href='/' className='hasdrop'>News
                <div className='customdropdown'>
                  <a href='/' className='hassubdrop'>
                    <div className='d-flex align-items-center justify-content-between'>
                      <span>Crypto News</span>
                      <div className='d-flex align-items-center'>
                        <span className='px-1 rounded-1 bg-danger fw-semibold text-white' style={{fontSize: '10px'}}>Trending</span>
                        <FontAwesomeIcon icon={faAngleRight} className='ms-1 fs-7' />
                      </div>
                    </div>
                    <div className='subcustomdropdown' style={{minWidth: '330px'}}>
                      {[...news] .sort(() => Math.random() - 0.5).slice(0, 3).map((newItem) => (
                        <div key={newItem.id} className='rounded-4 border d-flex p-2 mb-2'>
                          <div className='rounded-3 d-flex align-items-center justify-content-center overflow-hidden' style={{width: '110px', height: '70px', minWidth: '110px', minHeight: '70px'}}>
                            <img src={newItem.image || 'https://res.cloudinary.com/coinpaper/image/upload/v1680001325/arb_fba92b25bc.png'}alt={newItem.title}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = 'https://res.cloudinary.com/coinpaper/image/upload/v1680001325/arb_fba92b25bc.png'; // Fallback image
                            }} style={{width: '100%', height: '100%',objectFit: 'cover'}} />
                          </div>
                          <div className='flex-1 ms-2'>
                            <h6 className="mb-0 fw-semibold" style={{ fontSize: '14px' }}>
                              {newItem.title.split(' ').length <= 10
                                ? newItem.title
                                : `${newItem.title.split(' ').slice(0, 10).join(' ')}...`}
                            </h6>
                            <span className='mb-0' style={{fontSize: '10px', color: 'gray'}}>{newItem.date}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </a>
                  <a href='/' className='hassubdrop'>
                    <div className='d-flex align-items-center justify-content-between'>
                      <span>Press Releases</span>
                      <FontAwesomeIcon icon={faAngleRight} className='ms-1 fs-7' />
                    </div>
                    <div className='subcustomdropdown' style={{minWidth: '330px'}}>
                      {[...news] .sort(() => Math.random() - 0.5).slice(0, 3).map((newItem) => (
                        <div key={newItem.id} className='rounded-4 border d-flex p-2 mb-2'>
                          <div className='rounded-3 d-flex align-items-center justify-content-center overflow-hidden' style={{width: '110px', height: '70px', minWidth: '110px', minHeight: '70px'}}>
                            <img src={newItem.image || 'https://res.cloudinary.com/coinpaper/image/upload/v1680001325/arb_fba92b25bc.png'}alt={newItem.title}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = 'https://res.cloudinary.com/coinpaper/image/upload/v1680001325/arb_fba92b25bc.png'; // Fallback image
                            }} style={{width: '100%', height: '100%',objectFit: 'cover'}} />
                          </div>
                          <div className='flex-1 ms-2'>
                            <h6 className="mb-0 fw-semibold" style={{ fontSize: '14px' }}>
                              {newItem.title.split(' ').length <= 10
                                ? newItem.title
                                : `${newItem.title.split(' ').slice(0, 10).join(' ')}...`}
                            </h6>
                            <span className='mb-0' style={{fontSize: '10px', color: 'gray'}}>{newItem.date}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </a>
                  <a href='/' className='hassubdrop'>
                    <div className='d-flex align-items-center justify-content-between'>
                      <span>Daily Squeeze</span>
                      <div className='d-flex align-items-center'>
                        <span className='px-1 rounded-1 bg-primary fw-semibold text-white' style={{fontSize: '10px'}}>Exclusive</span>
                        <FontAwesomeIcon icon={faAngleRight} className='ms-1 fs-7' />
                      </div>
                    </div>
                    <div className='subcustomdropdown' style={{minWidth: '330px'}}>
                      {[...news] .sort(() => Math.random() - 0.5).slice(0, 3).map((newItem) => (
                        <div key={newItem.id} className='rounded-4 border d-flex p-2 mb-2'>
                          <div className='rounded-3 d-flex align-items-center justify-content-center overflow-hidden' style={{width: '110px', height: '70px', minWidth: '110px', minHeight: '70px'}}>
                            <img src={newItem.image || 'https://res.cloudinary.com/coinpaper/image/upload/v1680001325/arb_fba92b25bc.png'} alt={newItem.title}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = 'https://res.cloudinary.com/coinpaper/image/upload/v1680001325/arb_fba92b25bc.png'; // Fallback image
                            }} style={{width: '100%', height: '100%',objectFit: 'cover'}} />
                          </div>
                          <div className='flex-1 ms-2'>
                            <h6 className="mb-0 fw-semibold" style={{ fontSize: '14px' }}>
                              {newItem.title.split(' ').length <= 10
                                ? newItem.title
                                : `${newItem.title.split(' ').slice(0, 10).join(' ')}...`}
                            </h6>
                            <span className='mb-0' style={{fontSize: '10px', color: 'gray'}}>{newItem.date}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </a>
                </div>
              </a>
              <a href='/' className='hasdrop'>Data
                <div className='customdropdown'>
                  <a href='/'>Top Gainers & Losers</a>
                  <a href='/'>Crypto Market Overview</a>
                  <a href='/'>Fear And Greed Index</a>
                  <a href='/'><div className='d-flex align-items-center justify-content-between'>
                      <span>Analysis Reports</span>
                      <span className='px-1 rounded-1 bg-danger fw-semibold text-white' style={{fontSize: '10px'}}>Coming Soon</span>
                    </div>
                  </a>
                  <a href='/'><div className='d-flex align-items-center justify-content-between'>
                      <span>API</span>
                      <span className='px-1 rounded-1 bg-danger fw-semibold text-white' style={{fontSize: '10px'}}>Coming Soon</span>
                    </div>
                  </a>
                </div>
              </a>
              <a href='/'>Newsletter</a>
            </nav>
          </div>
          <div className='d-flex align-items-center'>
            <a href="https://dashboard.bitsmartasset.com" className='px-4 fs-7 fw-bold text-white d-none d-md-block' style={{textDecoration: 'none'}}>SIGN UP</a>
            <a href="https://dashboard.bitsmartasset.com" className='btn mybtn fs-7' style={{padding: '.7rem 1.2rem'}}>LOGIN</a>
            <div className='bg-linear d-lg-none d-flex align-items-center justify-content-center rounded-circle ms-3' style={{width: '40px', height: '40px'}} onClick={() => document.querySelector('.sidenav').classList.toggle('active')}>
              <FontAwesomeIcon icon={faBars} className='fs-5' style={{color: 'white'}} />
            </div>
          </div>
        </header>
        <section className='container herosection' style={{position:'relative', zIndex: 2}}>
          <div className='row px-lg-5 mx-xxl-5'>
            <div className='col-lg-6 col-12'>
              <div style={{maxWidth:'500px'}}>
                <h1 className='text-white headingText'>Trade a range of instruments from a single account</h1>
                <p className='mb-0 mt-4 text-white'>Expand your market reach, diversify your portfolio, and utilize our tools to manage your risk.</p>
                <div className='d-flex'>
                  <a href='https://dashboard.bitsmartasset.com' className='premiumBtn'>START TRADING</a>
                </div>
              </div>
            </div>
          </div>
          <div className='row mt-5 px-lg-5 mx-xxl-5'>
            <div className='col-md-3 col-6  g-4'>
              <div className='text-center'>
                <p className='mb-0 text-white' style={{fontSize:'40px'}}>0.0</p>
                <p className='mb-0 fs-4 text-white mt-lg-2' style={{fontWeight:'300',fontSize:'22px'}}>Pip spreads</p>
              </div>
            </div>
            <div className='col-md-3 col-6 g-4'>
              <div className='text-center'>
                <p className='mb-0 text-white' style={{fontSize:'40px'}}>1:500</p>
                <p className='mb-0 fs-4 text-white mt-lg-2' style={{fontWeight:'300',fontSize:'22px'}}>Leverage</p>
              </div>
            </div>
            <div className='col-md-3 col-6 g-4'>
              <div className='text-center'>
                <p className='mb-0 text-white' style={{fontSize:'40px'}}>20</p>
                <p className='mb-0 fs-4 text-white mt-lg-2' style={{fontWeight:'300',fontSize:'22px'}}>Years experience</p>
              </div>
            </div>
            <div className='col-md-3 col-6 g-4'>
              <div className='text-center'>
                <p className='mb-0 text-white' style={{fontSize:'40px'}}>24/7</p>
                <p className='mb-0 fs-4 text-white mt-lg-2' style={{fontWeight:'300',fontSize:'22px'}}><span className='d-none d-md-inline'>Customer</span> support</p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <main className='pb-5 pt-md-5 pt-4'>
        <div className='container mt-lg-5 pb-lg-5'>
          <div className='row px-lg-5 mx-xxl-5'>
            <div className='col-lg-3 col-md-4 col-6 g-md-4 g-2'>
              <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{backgroundColor:'#f4f4f4'}}>
                <img src="./img/card-zero@2x.webp" alt="" style={{height:'90px'}}/>
                <p className='mb-0 text-center' style={{fontSize:'17px',fontWeight:'300',maxWidth:'140px'}}>Tight spreads from 0.0 pips</p>
              </div>
            </div>
            <div className='col-lg-3 col-md-4 col-6 g-md-4 g-2'>
              <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{backgroundColor:'#f4f4f4'}}>
                <img src="./img/card-money@2x.webp" alt="" style={{height:'90px'}}/>
                <p className='mb-0 text-center' style={{fontSize:'17px',fontWeight:'300',maxWidth:'140px'}}>$100 minimum deposit</p>
              </div>
            </div>
            <div className='col-lg-3 col-md-4 col-6 g-md-4 g-2'>
              <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{backgroundColor:'#f4f4f4'}}>
                <img src="./img/card-thunder@2x.webp" alt="" style={{height:'90px'}}/>
                <p className='mb-0 text-center' style={{fontSize:'17px',fontWeight:'300',maxWidth:'140px'}}>Fast execution speeds</p>
              </div>
            </div>
            <div className='col-lg-3 col-md-12 col-6 g-md-4 g-2'>
              <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{backgroundColor:'#f4f4f4'}}>
                <img src="./img/card-chart@2x.webp" alt="" style={{height:'90px'}}/>
                <p className='mb-0 text-center' style={{fontSize:'17px',fontWeight:'300',maxWidth:'140px'}}>Trader-centric technology</p>
              </div>
            </div>
          </div>
          <h2 className='mt-5 mb-5 pt-lg-4 text-black' style={{fontWeight:'600',fontSize:'1.625rem',lineHeight:'130%',letterSpacing:'-.01em'}}>What can you trade with Bitsmartasset?</h2>
          <Splide
            options={{
              type: "loop",
              perMove: 1,
              perPage: 4,
              gap: "1rem",
              arrows: true,
              pagination: false,
              autoplay: true,
              interval: 5000,
              breakpoints: {
                1200: {
                  perPage: 4,
                },
                992: {
                  perPage: 2,
                },
                768: {
                  perPage: 1,
                },
              },
            }}
          >
            <SplideSlide>
              <div className='position-relative d-flex align-items-center justify-content-center'>
                <img src="./img/trading@2x.webp" alt="Image 1" style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                <div className='position-absolute' style={{top:'40px',left:'24px',maxWidth:'220px',marginRight:'24px'}}>
                  <h4 className='text-white' style={{fontSize:'24px',fontWeight:'600',lineHeight:'1.2',letterSpacing:'-.01em',marginBottom:'.8rem'}}>Forex</h4>
                  <p className='mb-0 text-white' style={{fontSize:'15px',lineHeight:'1.3'}}>Trade 70+ major, minor and exotic currency pairs.</p>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className='position-relative d-flex align-items-center justify-content-center'>
                <img src="./img/cfd@2x.webp" alt="Image 2" style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                <div className='position-absolute' style={{top:'40px',left:'24px',maxWidth:'220px',marginRight:'24px'}}>
                  <h4 className='mb-2 text-black' style={{fontSize:'22px',fontWeight:'600',lineHeight:'1.2',letterSpacing:'-.01em',marginBottom:'.8rem'}}>Shares</h4>
                  <p className='mb-0 text-black' style={{fontSize:'15px',lineHeight:'1.3'}}>Trade stocks of the most popular listed companies in the world.</p>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className='position-relative d-flex align-items-center justify-content-center'>
                <img src="./img/metals@2x.webp" alt="Image 2" style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                <div className='position-absolute' style={{top:'40px',left:'24px',maxWidth:'220px',marginRight:'24px'}}>
                  <h4 className='mb-2 text-black' style={{fontSize:'22px',fontWeight:'600',lineHeight:'1.2',letterSpacing:'-.01em',marginBottom:'.8rem'}}>Metals</h4>
                  <p className='mb-0 text-black' style={{fontSize:'15px',lineHeight:'1.3'}}>Trade Gold, Silver, Platinum and other metals.</p>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className='position-relative d-flex align-items-center justify-content-center'>
                <img src="./img/commodities@2x.webp" alt="Image 2" style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                <div className='position-absolute' style={{top:'40px',left:'24px',maxWidth:'220px',marginRight:'24px'}}>
                  <h4 className='mb-2 text-white' style={{fontSize:'22px',fontWeight:'600',lineHeight:'1.2',letterSpacing:'-.01em',marginBottom:'.8rem'}}>Commodities</h4>
                  <p className='mb-0 text-white' style={{fontSize:'15px',lineHeight:'1.3'}}>Trade commodities such as Oil, Gas, Corn and Sugar.</p>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className='position-relative d-flex align-items-center justify-content-center'>
                <img src="./img/indices@2x.webp" alt="Image 2" style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                <div className='position-absolute' style={{top:'40px',left:'24px',maxWidth:'220px',marginRight:'24px'}}>
                  <h4 className='mb-2 text-black' style={{fontSize:'22px',fontWeight:'600',lineHeight:'1.2',letterSpacing:'-.01em',marginBottom:'.8rem'}}>Indices</h4>
                  <p className='mb-0 text-black' style={{fontSize:'15px',lineHeight:'1.3'}}>Trade major global stock indices including the NASDAQ 100 and S&P 500.</p>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className='position-relative d-flex align-items-center justify-content-center'>
                <img src="./img/crypto@2x.webp" alt="Image 2" style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                <div className='position-absolute' style={{top:'40px',left:'24px',maxWidth:'220px',marginRight:'24px'}}>
                  <h4 className='mb-2 text-black' style={{fontSize:'22px',fontWeight:'600',lineHeight:'1.2',letterSpacing:'-.01em',marginBottom:'.8rem'}}>Digital Currencies</h4>
                  <p className='mb-0 text-black' style={{fontSize:'15px',lineHeight:'1.3'}}>Trade Bitcoin, Ethereum, Litecoin and altcoins.</p>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className='position-relative d-flex align-items-center justify-content-center'>
                <img src="./img/etf@2x.webp" alt="Image 2" style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                <div className='position-absolute' style={{top:'40px',left:'24px',maxWidth:'220px',marginRight:'24px'}}>
                  <h4 className='mb-2 text-white' style={{fontSize:'22px',fontWeight:'600',lineHeight:'1.2',letterSpacing:'-.01em',marginBottom:'.8rem'}}>ETFs</h4>
                  <p className='mb-0 text-white' style={{fontSize:'15px',lineHeight:'1.3'}}>Trade multiple investment classes and sectors with ETFs.</p>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className='position-relative d-flex align-items-center justify-content-center'>
                <img src="./img/bonds@2x.webp" alt="Image 2" style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                <div className='position-absolute' style={{top:'40px',left:'24px',maxWidth:'220px',marginRight:'24px'}}>
                  <h4 className='mb-2 text-black' style={{fontSize:'22px',fontWeight:'600',lineHeight:'1.2',letterSpacing:'-.01em',marginBottom:'.8rem'}}>Bonds</h4>
                  <p className='mb-0 text-black' style={{fontSize:'15px',lineHeight:'1.3'}}>Trade UK Long-term Bond gilts and US 10-year Treasury Notes.</p>
                </div>
              </div>
            </SplideSlide>


          </Splide>
          <div className='row mt-md-5 mt-4 pt-md-5 ps-lg-5 ms-xxl-5'>
            <div className='col-lg-4 col-md-6 g-lg-4 g-md-2 g-4'>
              <h1 className='text-black mb-4' style={{lineHeight:'1.1',fontWeight:'600'}}>Tighter spreads. <br/> Faster execution.</h1>
              <p className='mb-0 text-black' style={{fontSize:'17px',fontWeight:'300',letterSpacing:'-.01em',lineHeight:'160%'}}>Our trading technology is engineered for speed and precision. You can trade the markets on your terms by taking advantage of our low spreads, consistent liquidity and market-leading execution.</p>
              <ul className='mt-4 customlist'>
                <li>Spreads as low as 0.0 pips</li>
                <li>Fast execution from an NY4/LD4 server facility</li>
                <li>Top-tier liquidity and market leading pricing</li>
              </ul>
              <a href='https://dashboard.bitsmartasset.com' className='btn mybtn fs-7 mt-5'>START TRADING</a>
            </div>
            <div className='col-lg-7 offset-lg-1 col-md-6 g-lg-4 g-md-2 g-4'>
              <div className='w-100 overflow-hidden dedde'>
                <img src="./img/serverimage@2x.webp" alt="" style={{width:'100%'}}/>
              </div>
            </div>
          </div>
          <div className='customCard'>
            <div className='row mobileReverse'>
              <div className='col-lg-7 col-md-6 customHeight'>
                <div className='position-relative'>
                  <img src="./img/dna@2x.webp" alt="" className='floatingImg'/>
                </div>
              </div>
              <div className='col-lg-5 col-md-6'>
                <h1 className='text-black' style={{lineHeight:'1.1',fontWeight:'600'}}>Trade technology is in our DNA</h1>
                <ul className='mt-4 customlist'>
                  <li>20+ years of trading experience</li>
                  <li>60+ international awards</li>
                  <li>Globally regulated brand</li>
                  <li>Segregated client funds</li>
                  <li>24/7 multilingual Customer Support</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className='bdg px-md-5 py-5 mt-5' style={{backgroundImage: "url('/img/couple-bg@2x.png')"}}>
          <div className='container p-lg-5 my-lg-5'>
            <h1 className='text-center text-white mx-auto mb-4 bigText' style={{lineHeight:'1.1',maxWidth:'800px'}}>Learn and trade what you want. When you want.</h1>
            <p className='mb-0 mx-auto text-white text-center' style={{maxWidth:'25rem',lineHeight:'160%',fontWeight:'300',letterSpacing:'-.01em'}}>Improve your strategy and become a more confident trader with expert market analysis, advanced trading tools and comprehensive educational materials.</p>
            <div className='d-flex justify-content-center mt-5'>
              <a href='https://dashboard.bitsmartasset.com' className='premiumBtn'>START TRADING</a>
            </div>
          </div>
        </div>
        <div className='container mt-5 pt-lg-5'>
          <div className='customCard smallP'>
            <div className='row'>
              <div className='col-lg-5 col-md-6'>
                <h1 className='text-black' style={{lineHeight:'1.1',fontWeight:'600'}}>Social Trading: follow & copy top-performing traders</h1>
                <ul className='mt-4 customlist'>
                  <li>Follow skilled traders with a proven track record</li>
                  <li>Copy their strategies in real-time</li>
                  <li>Diversify your investment portfolio</li>
                  <li>No need to develop your own trading plan</li>
                  <li>Become both a Copier and Provider</li>
                </ul>
                <div>
                  <a href='https://dashboard.bitsmartasset.com' className='btn mybtn fs-7 mt-5'>START TRADING</a>
                </div>
              </div>
              <div className='col-lg-7 col-md-6 customHeight'>
                <div className='position-relative'>
                  <img src="./img/hand@2x.webp" alt="" className='floatingImg1'/>
                </div>
              </div>
            </div>
          </div>
          <h1 className='mb-4 text-black text-center mt-5 pt-lg-5 mx-auto' style={{maxWidth:'800px',fontWeight:'600',lineHeight:'110%',letterSpacing:'-.01em'}}>Why is Bitsmartasset one of the world’s most trusted brokers?</h1>
          <div className='row px-lg-5 mx-xxl-5 pb-lg-5'>
            <div className='col-lg-3 col-md-4 col-6 g-md-4 g-2'>
              <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{backgroundColor:'#f4f4f4'}}>
                <img src="./img/multi-regulated.svg" alt="" style={{height:'90px'}}/>
                <p className='mb-0 text-center' style={{fontSize:'17px',fontWeight:'300',maxWidth:'140px'}}>20+ years trading experience</p>
              </div>
            </div>
            <div className='col-lg-3 col-md-4 col-6 g-md-4 g-2'>
              <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{backgroundColor:'#f4f4f4'}}>
                <img src="./img/segregation.svg" alt="" style={{height:'90px'}}/>
                <p className='mb-0 text-center' style={{fontSize:'17px',fontWeight:'300',maxWidth:'140px'}}>Multi-regulated brand</p>
              </div>
            </div>
            <div className='col-lg-3 col-md-4 col-6 g-md-4 g-2'>
              <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{backgroundColor:'#f4f4f4'}}>
                <img src="./img/globe.svg" alt="" style={{height:'90px'}}/>
                <p className='mb-0 text-center' style={{fontSize:'17px',fontWeight:'300',maxWidth:'140px'}}>60+ international awards</p>
              </div>
            </div>
            <div className='col-lg-3 col-md-12 col-6 g-md-4 g-2'>
              <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{backgroundColor:'#f4f4f4'}}>
                <img src="./img/spreads.svg" alt="" style={{height:'90px'}}/>
                <p className='mb-0 text-center' style={{fontSize:'17px',fontWeight:'300',maxWidth:'140px'}}>Transparent trading conditions</p>
              </div>
            </div>
          </div>
          <div className='customCard mt-5'>
            <div className='row'>
              <div className='col-lg-5 col-md-6'>
                <h1 className='text-black' style={{lineHeight:'1.1',fontWeight:'600'}}>Transforming the Trading Experience</h1>
                <p className='mb-0 text-black' style={{fontSize:'17px',fontWeight:'300',letterSpacing:'-.01em',lineHeight:'160%'}}>Transforming trading is more than just a mission statement. It is embedded in everything we do at bitsmartasset. We build scalable, sustainable and reliable financial technology that puts the trader first.</p>
              </div>
              <div className='col-lg-7 col-md-6 customHeight'>
                <div className='position-relative'>
                  <img src="./img/market@2x.webp" alt="" className='floatingImg1'/>
                </div>
              </div>
            </div>
          </div>
          <div className='mt-5 pt-md-5' id='features'>
            <h1 className='text-center display-5 lh-1 text-black'>Comparison With Competitors and <br/> Our Advantages</h1>
            <p className='text-secondary text-center fs-5'>Analyzing competitors showcases our standout advantages</p>
              <table
                className="table table-light table-striped table-borderless advantages-table"
              >
                <thead className='d-md-table-head'>
                  <tr>
                    <th className='ps-md-5'>Futures</th>
                    <th className='text-center'>IDV System</th>
                    <th className='text-center'>Creating Apps</th>
                    <th className='text-center'>Confidentiality</th>
                    <th className='text-center pe-md-5'>Without Gadget</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className='d-md-tables'>
                    <td colSpan='5' className='py-4'></td>
                  </tr>
                  <tr className='px-md-4'>
                    <td className='ps-md-5 fw-bold'>coindox</td>
                    <td className='text-center'><img src='./img/badge_active.svg' alt='check'/></td>
                    <td className='text-center'><img src='./img/badge_deactive.svg' alt='check'/></td>
                    <td className='text-center'><img src='./img/badge_active.svg' alt='check'/></td>
                    <td className='text-center pe-md-5'><img src='./img/badge_deactive.svg' alt='check'/></td>
                  </tr>
                  <tr className='px-md-4'>
                    <td className='ps-md-5 fw-bold'>Civic</td>
                    <td className='text-center'><img src='./img/badge_active.svg' alt='check'/></td>
                    <td className='text-center'><img src='./img/badge_deactive.svg' alt='check'/></td>
                    <td className='text-center'><img src='./img/badge_active.svg' alt='check'/></td>
                    <td className='text-center pe-md-5'><img src='./img/badge_deactive.svg' alt='check'/></td>
                  </tr>
                  <tr className='px-md-4'>
                    <td className='ps-md-5 fw-bold'>Vilid.global</td>
                    <td className='text-center'><img src='./img/badge_active.svg' alt='check'/></td>
                    <td className='text-center'><img src='./img/badge_deactive.svg' alt='check'/></td>
                    <td className='text-center'><img src='./img/badge_active.svg' alt='check'/></td>
                    <td className='text-center pe-md-5'><img src='./img/badge_deactive.svg' alt='check'/></td>
                  </tr>
                  <tr className='px-md-4'>
                    <td className='ps-md-5 fw-bold'>Hypr</td>
                    <td className='text-center'><img src='./img/badge_active.svg' alt='check'/></td>
                    <td className='text-center'><img src='./img/badge_active.svg' alt='check'/></td>
                    <td className='text-center'><img src='./img/badge_deactive.svg' alt='check'/></td>
                    <td className='text-center pe-md-5'><img src='./img/badge_active.svg' alt='check'/></td>
                  </tr>
                </tbody>
              </table>
          </div>
          <div className='mt-5'>
            <div className='d-flex justify-content-center'>
              <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button className="nav-link active" id="pills-selects-tab" data-bs-toggle="pill" data-bs-target="#pills-selects" type="button" role="tab" aria-controls="pills-selects" aria-selected="true">Selects</button>
                </li>
                <li className="nav-item" role="presentation">
                  <button className="nav-link" id="pills-buys-tab" data-bs-toggle="pill" data-bs-target="#pills-buys" type="button" role="tab" aria-controls="pills-buys" aria-selected="false">Buys</button>
                </li>
                <li className="nav-item" role="presentation">
                  <button className="nav-link" id="pills-sells-tab" data-bs-toggle="pill" data-bs-target="#pills-sells" type="button" role="tab" aria-controls="pills-sells" aria-selected="false">Sells</button>
                </li>
                <li className="nav-item d-none d-md-block" role="presentation">
                  <button className="nav-link" id="pills-gets-tab" data-bs-toggle="pill" data-bs-target="#pills-gets" type="button" role="tab" aria-controls="pills-gets" aria-selected="false">Gets profit</button>
                </li>
              </ul>
            </div>
            <div className="tab-content mx-lg-5" id="pills-tabContent">
              <div className="tab-pane fade mx-lg-5 show active" id="pills-selects" role="tabpanel" aria-labelledby="pills-selects-tab" tabIndex="0">
                <div className='p-4 rounded-5 row align-items-center mt-4' style={{backgroundColor: '#04182F'}}>
                  <div className='col-md-5'>
                    <img src='./img/4rfrf-768x1000.png' className='img-fluid' style={{maxHeight: '390px'}} alt='img'/>
                  </div>
                  <div className='col-md-6'>
                    <h1 className='text-white mb-0'>Selects Popular Markets</h1>
                    <p className='text-secondary fs-5'>Access the world's most traded financial markets, including Forex, Stocks, Indices, Commodities, Metals, and Cryptocurrencies.</p>
                    <a href='https://dashboard.bitsmartasset.com' className='fw-bold fs-5 text-info'>Show More</a>
                  </div>
                </div>
              </div>
              <div className="tab-pane fade mx-lg-5" id="pills-buys" role="tabpanel" aria-labelledby="pills-buys-tab" tabIndex="0">
                <div className='p-4 rounded-5 row align-items-center mt-4' style={{backgroundColor: '#04182F'}}>
                  <div className='col-md-5'>
                    <img src='./img/rvgrv-768x669.png' className='img-fluid' style={{maxHeight: '390px'}} alt='img'/>
                  </div>
                  <div className='col-md-6'>
                    <h1 className='text-white mb-0'>Buys Assets More Likely to Grow</h1>
                    <p className='text-secondary fs-5'>Identify opportunities with advanced market insights and trade assets that show strong growth potential.</p>
                    <a href='https://dashboard.bitsmartasset.com' className='fw-bold fs-5 text-info'>Show More</a>
                  </div>
                </div>
              </div>
              <div className="tab-pane fade mx-lg-5" id="pills-sells" role="tabpanel" aria-labelledby="pills-sells-tab" tabIndex="0">
                <div className='p-4 rounded-5 row align-items-center mt-4' style={{backgroundColor: '#04182F'}}>
                  <div className='col-md-5'>
                    <img src='./img/ctgtgct-768x595.png' className='img-fluid' style={{maxHeight: '390px'}} alt='img'/>
                  </div>
                  <div className='col-md-6'>
                    <h1 className='text-white mb-0'>Sells Assets That May Go Down</h1>
                    <p className='text-secondary fs-5'>Take advantage of both rising and falling markets with flexible trading strategies and real-time market analysis.</p>
                    <a href='https://dashboard.bitsmartasset.com' className='fw-bold fs-5 text-info'>Show More</a>
                  </div>
                </div>
              </div>
              <div className="tab-pane fade mx-lg-5" id="pills-gets" role="tabpanel" aria-labelledby="pills-gets-tab" tabIndex="0">
                <div className='p-4 rounded-5 row align-items-center mt-4' style={{backgroundColor: '#04182F'}}>
                  <div className='col-md-5'>
                    <img src='./img/5tgt5-768x798.png' className='img-fluid' style={{maxHeight: '390px'}} alt='img'/>
                  </div>
                  <div className='col-md-6'>
                    <h1 className='text-white mb-0'>Tracks Profitable Market Opportunities</h1>
                    <p className='text-secondary fs-5'>Stay ahead of market movements with live price updates, smart tools, and timely trading opportunities across global markets.</p>
                    <a href='https://dashboard.bitsmartasset.com' className='fw-bold fs-5 text-info'>Show More</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-5 pt-lg-5">
            <h1 className='text-black mb-4 text-center' style={{lineHeight:'1.1',fontWeight:'600'}}>Ready to transform your trading?</h1>
            <p className='mb-0 text-black text-center' style={{fontSize:'17px',fontWeight:'300',letterSpacing:'-.01em',lineHeight:'160%'}}>Open your live trading account in 3 simple steps</p>
            <div className='row'>
              <div className='col-lg-4 col-md-6 g-5'>
                <div className='d-flex flex-column justify-content-between h-100' style={{padding:'3rem 2rem 0',backgroundColor:'#f4f4f4f2',gap:'auto'}}>
                  <div>
                    <h4 className='mb-3 text-black' style={{fontWeight:'600'}}>1 Register</h4>
                    <p className='mb-0 text-black' style={{fontSize:'16px',fontWeight:'300'}}>Choose your account type and complete our fast and secure application form.</p>
                  </div>
                  <img src="./img/register@2x.webp" alt="" className='w-100'/>
                </div>
              </div>
              <div className='col-lg-4 col-md-6 g-5'>
                <div className='d-flex flex-column justify-content-between h-100' style={{padding:'3rem 2rem 0',backgroundColor:'#f4f4f4f2',gap:'auto'}}>
                  <div>
                    <h4 className='mb-3 text-black' style={{fontWeight:'600'}}>2 Fund</h4>
                    <p className='mb-0 text-black' style={{fontSize:'16px',fontWeight:'300'}}>Fund your trading account using a wide range of instant and secure deposit methods.</p>
                  </div>
                  <img src="./img/fund@2x.webp" alt="" className='w-100'/>
                </div>
              </div>
              <div className='col-lg-4 col-md-6 g-5'>
                <div className='d-flex flex-column justify-content-between h-100' style={{padding:'3rem 2rem 0',backgroundColor:'#f4f4f4f2',gap:'auto'}}>
                  <div>
                    <h4 className='mb-3 text-black' style={{fontWeight:'600'}}>3 Trade</h4>
                    <p className='mb-0 text-black' style={{fontSize:'16px',fontWeight:'300'}}>Start trading 10,000 instruments on 5+ platforms with spreads as low as 0.0 pips.</p>
                  </div>
                  <img src="./img/trade@2x.webp" alt="" className='w-100'/>
                </div>
              </div>
            </div>
            <div className='d-flex justify-content-center'>
              <a href='https://dashboard.bitsmartasset.com' className='btn mybtn fs-7 mt-5'>START TRADING</a>
            </div>
          </div>
          <div className='mt-5 pt-md-5' id='events'>
            <h1 className='fw-bold text-black text-center display-5 mb-4'>Join Events for meet us</h1>
            <div className='row'>
              {news.slice(0, 4).map((newItem) => (
              <div key={newItem.id} className='col-lg-3 col-md-6 col-12 g-4'>
                <div className='blog-card'>
                  <div className='blogImg mb-3'>
                    <img src={newItem.image || 'https://res.cloudinary.com/coinpaper/image/upload/v1680001325/arb_fba92b25bc.png'} alt={newItem.title}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://res.cloudinary.com/coinpaper/image/upload/v1680001325/arb_fba92b25bc.png'; // Fallback image
                    }} style={{width: '100%'}} />
                  </div>
                  <h6 className='text-black'>{newItem.title.split(' ').length <= 10
                    ? newItem.title
                    : `${newItem.title.split(' ').slice(0, 10).join(' ')}...`}</h6>
                  <p className='text-black mb-2' style={{textTransform:'capitalize'}}><FontAwesomeIcon icon={faLocationDot} className='fs-7 text-primary fw-bold me-2' /> {newItem.country}</p>
                  <p className='text-black mb-0'><FontAwesomeIcon icon={faClock} className='fs-7 text-primary fw-bold me-2' /> {newItem.date}</p>
                  <a href='https://dashboard.bitsmartasset.com' className='btn mybtn px-5 fs-7 mt-4' style={{paddingTop: '12px',paddingBottom: '12px'}}>JOIN US</a>
                </div>
              </div>
              ))}
            </div>
          </div> 
        </div>
      </main>
      <footer className='mt-5 py-5' style={{backgroundColor:'#0a121c'}}>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-4 col-md-6 g-5'>
              <h3 className='fw-bold text-white mb-3'>Bitsmartasset</h3>
              <p className='text-white'>Your trusted partner for online trading, providing access to global markets with advanced technology, transparent pricing, and a seamless trading experience.</p>
            </div>
            <div className='col-lg-4 col-md-6 g-5'>
              <p className='fw-bold mb-0 text-white ps-4' style={{borderLeft: '3px solid #0032ff'}}>Contact Us</p>
              <p className='my-3 text-white'>39 Ivy Lane, Walton, United Kingdom.</p>
              <p className='mb-3 text-white'>support@bitsmartasset.com</p>
            </div>
            <div className='col-lg-4 col-md-6 g-5'>
              <p className='fw-bold mb-0 text-white ps-4' style={{borderLeft: '3px solid #0032ff'}}>Sign Up for Email Updates</p>
              <input type='search' className='form-control fadeInput' placeholder='Your e-mail address'/>
              <p className='my-3 text-white'>Sign up with your email address to receive news and updates</p>
            </div>
          </div>
          <hr/>
          <div className='row'>
            <div className='col-md-6'><p className='mb-0 text-secondary'>© 2026 bitsmartasset. All rights reserved.</p></div>
            <div className='col-md-6'>
              <div className='footernav justify-content-end'>
                <a href='#home' className='active'>HOME</a>
                <a href='#blockchain'>BLOCKCHAIN</a>
                <a href='#features'>FEATURES</a>
                <a href='#events'>EVENTS</a>
                <a href='#reviews'>REVIEWS</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;